// i18n.js cu namespace-uri
import { createI18n } from 'vue-i18n'
import en from './en.json'
import ro from './ro.json'

// Read saved language
const savedLanguage = localStorage.getItem('user-language') || 'ro';

const messages = {
  en: en,
  ro: ro
}

const i18n = createI18n({
  locale: savedLanguage, // set locale implicit
  fallbackLocale: 'ro', // set fallback locale
  messages, // set locale messages
})

export default i18n